export default __webpack_public_path__ + "static/media/path-doughnut-blue.2c42832f.svg";